const errorsHandler = {
    methods: {
        $handleErrors(error) {
            if ( error.status === 404) {
                console.error('User not found. Please check and try again');
                this.$showErrorMessage('User not found. Please check and try again');
            } else if ( error.status === 422) {
                console.error('User data is incorrect', error);
                this.$showErrorMessage('User data is incorrect', 'Please enter correct Name and Last Name');
            } else {
                console.error('Other error', error);
                this.$showErrorMessage('Something went wrong');
            }
        }
    }
}

export default errorsHandler;
